import { trainTypeImgs } from "./constants";

export function getTrainBreadcrumbs(trains){
	const result = [];
	if(!trains) return result;
	for (const train of trains) {
		if(train.type == 'multi' && train.subSegments){
			result.push(...getTrainBreadcrumbs(train.subSegments))
		}else{
			let icon = trainTypeImgs[train.type];
			if(!icon) icon = trainTypeImgs.default;
			result.push(Object.assign({}, train, {
				icon,
				departureLocalTimeStr: new Date(train.departure).toLocaleTimeString(undefined, {hour:'2-digit', minute:'2-digit', hour12: false}),
				arrivalLocalTimeStr: new Date(train.arrival).toLocaleTimeString(undefined, {hour:'2-digit', minute:'2-digit', hour12: false})
			}));
		}
	}
	return result;
}